import React from 'react';
import { Grid } from '@mui/material';
import AppLayout from '../../layout/app.layout';
import Counters from '../../components/reports/counters.component';
import WatchedSecondsChart from '../../components/reports/watched-seconds-chart.component';
import useAccess from '../../hooks/access.hook';
import PageLinks from '../../components/reports/page-links.component';

const DashboardView = () => {
  const pageTitle = 'Dashboard';

  const { hasContentOwnerAccess, hasOperationAccess } = useAccess();

  return (
    <AppLayout pageTitle={pageTitle}>
      {!hasContentOwnerAccess() ? (
        <>
          <Counters />

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <WatchedSecondsChart />
            </Grid>
          </Grid>
        </>
      ) : (
        <PageLinks
          canEditLicense={hasOperationAccess('license_management', 'manage')}
        />
      )}
    </AppLayout>
  );
};

export default DashboardView;
